export function isEmpty(array) {
    return !array || array.length === 0;
}

export function ifTrue(data) {
    if (data) {
        return true;
    }

    if (data === 0) {
        return true;
    }

    return false;
}

export function isArrayData(data) {
    return (data && data instanceof Array);
}

export function arrayJoinToStr(array, fun, separator = ',') {
    if (!(array instanceof Array)) {
        return '';
    }
    if (array.length === 0) {
        return '';
    }
    let str = '';
    array.forEach((v, i) => {
        if (i > 0) {
            str += separator;
        }
        if (fun) {
            str += fun(v);
        } else {
            str += v;
        }
    });
    return str;
}